import { Injectable, ErrorHandler, Injector,NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {MatDialog}from'@angular/material'
import{GlobalErrorComponent}from'./global-error.component'
@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
    constructor(private injector: Injector,private zone:NgZone,private matDialog:MatDialog) { }    

    handleError(error: any) {
      //let router = this.injector.get(Router);
      // console.log('URL: ' + router.url);
      
      if (error instanceof HttpErrorResponse) {
        // console.log('Server Side Error Occured')			  
        // console.error('Status code: ', error.status);
        // console.error('Response body:', error.message);    
         console.log(error)   

      } else {
          //A client-side or network error occurred.	          
          // console.error('Client Side Error Occured:');
       
           console.log(error) 
          // this.zone.run(()=>{
          //   const dialogRef=this.matDialog.open(GlobalErrorComponent,{width:'50%',height:'70%',data:error})
          //   dialogRef.afterClosed().subscribe(result => {
          //   });
          // })       
      }     
     
      
    }
} 